/**
 * English: User-facing settings shell around the shared settings form component.
 * Thai: เปลือกหน้าตั้งค่าผู้ใช้ ห่อคอมโพเนนต์ฟอร์มตั้งค่าร่วม
 */
import { useTranslation } from 'react-i18next';
import { Cog6ToothIcon, CpuChipIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import SettingsForm from '../components/settings/SettingsForm';
import LLMSettingsForm from '../components/settings/LLMSettingsForm';
import SettingsSection from '../components/settings/SettingsSection';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';

export default function SettingsPage() {
  const { t } = useTranslation();

  return (
    <PageShell wide>
      <PageHeader title={t('settings.title')} description={t('settings.pageDescription')} />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start">
        <div className="lg:col-span-8">
          <SettingsSection
            id="llm-settings"
            icon={CpuChipIcon}
            title={t('settings.llm.title')}
            description={t('settings.llm.subtitleSingleOrg')}
            featured
            bodyClassName="p-0"
          >
            <LLMSettingsForm />
          </SettingsSection>
        </div>

        <aside className="lg:col-span-4 flex flex-col gap-6">
          <SettingsSection
            id="connection-settings"
            icon={Cog6ToothIcon}
            title={t('settings.configuration')}
            description={t('settings.connectionSectionHint')}
          >
            <SettingsForm compact />
          </SettingsSection>

          <SettingsSection
            id="about"
            icon={InformationCircleIcon}
            title={t('settings.about')}
            bodyClassName="py-4"
          >
            <dl className="space-y-3 text-sm">
              <div>
                <dt className="text-xs text-app-text-dim">{t('settings.appName')}</dt>
                <dd className="font-medium text-app-text mt-0.5">v2.0</dd>
              </div>
              <div>
                <dt className="text-xs text-app-text-dim">{t('settings.stackLabel')}</dt>
                <dd className="text-app-text-sec mt-0.5">{t('settings.stack')}</dd>
              </div>
            </dl>
          </SettingsSection>
        </aside>
      </div>
    </PageShell>
  );
}
